import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";
import { initialProductDetailState } from "../../models/productDetailModel";

export const fetchProductDetail = createAsyncThunk(
  "product/fetchProductDetail",
  async (productId, thunkAPI) => {
    try {
      const response = await apiService(
        "/Showcase/GetAllByProduct",
        "GET",
        null,
        productId
      );
      if (response.isSuccess) {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response.message || "Hata oluştu");
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const productDetailSlice = createSlice({
  name: "productDetail",
  initialState: initialProductDetailState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.dataProductDetail = state.dataProductDetail
          ? [...state.dataProductDetail, ...action.payload]
          : action.payload;
      })
      .addCase(fetchProductDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default productDetailSlice.reducer;
